import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M14.216 2.505a9.75 9.75 0 1 0 3.712 17.236.75.75 0 1 0-.912-1.191A8.25 8.25 0 1 1 20.25 12v.9a1.95 1.95 0 0 1-3.329 1.378.57.57 0 0 1-.17-.38 3 3 0 0 1-.011-.371l.003-.154c.004-.115.007-.249.007-.373V8.5a.75.75 0 0 0-1.5 0v.388a4.5 4.5 0 1 0 .24 5.953c.09.17.21.338.37.498a3.45 3.45 0 0 0 5.89-2.44V12a9.75 9.75 0 0 0-7.534-9.494M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }